// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/registry.npmjs.org/css-loader/3.6.0_webpack@4.43.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.svelte-hllavj{list-style:none;display:flex;padding:0px;margin:0px;grid-column:span 2}li.svelte-hllavj{margin-right:0.25em}li.svelte-hllavj:after{content:\", \"}li.svelte-hllavj:last-child:after{content:\"\"}", ""]);
// Exports
module.exports = exports;
